import { FC } from "react";
import { Box } from "@material-ui/core";
import { useStyles } from "./style";
import DashboardHead from "./DashboardHead";
import Loader from "router/components/Loader";
import DashboardBody from "./DashboardBody";
import { useTypeSelectors } from "hooks/useTypeSelectors";

interface PropsType {}

const Dashboard: FC<PropsType> = () => {
  const classes = useStyles();
  const { loadingData } = useTypeSelectors((state) => state.dashboard);

  return (
    <Box data-testid="testDashboard" className={classes.root}>
      <Loader isLoading={loadingData}/>
      <DashboardHead/>
      <DashboardBody/>
    </Box>
  );
};

export default Dashboard;
